import React,{useState} from 'react'
import { ModalContainer,UIcon,IconContainer, MainContentContainer1,SubmitContainer,StyleButton,StyleLabel} from './CreateAdminUser';
import { useSettingModal } from '../../../../hooks/Context';
import styled from '@emotion/styled';
import { useMutation,useQueryClient } from '@tanstack/react-query';
import { apiFormRequest,apiRequest } from '../../../../api';

const DeleteAdminConfig = (props:any) => {
    const data = props.data;
    const {setShowCancel,setShowModal} = useSettingModal();
    const [loading,setLoading] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const onDelete = async() =>{
      const Id = data.ApprovalConfigId;
     
      return await apiRequest(`api/ApprovalConfig/DelApprovalConfig/${Id}`,'DELETE');
    }
    const deleteAdminConfig = useMutation(onDelete,{
      onSuccess(data, variables, context) {
        
      },
      onError(error, variables, context) {
        
      },
      onSettled(data, error, variables, context) {
        
      },
    })
    const handleDelete = (e:any)=>{
      e.preventDefault();
      deleteAdminConfig.mutate();
    }
   
  return (
    <ModalContainer>
    <div>
      <div>
        <div>
          <IconContainer><UIcon /></IconContainer>
          <span>Delete Approval Configuration?</span>
          </div>
        </div>
        <div>
        <MainContentContainer1 onSubmit={handleDelete}>
          <Title>You are about to delete <span>Approval Configuration.</span></Title>
          <SubmitContainer>
                 <span onClick={()=>setShowModal(false)}>Cancel</span>
                 <StyleButton style={{backgroundColor:'#DD5151'}}>
                  {loading?'Loading':'Delete'}
                 </StyleButton>
              </SubmitContainer>
        </MainContentContainer1>
        </div>
      </div>
      </ModalContainer>
  )
}

export default DeleteAdminConfig;

const Title = styled.div`
    font-size:18px;
    & > span{
        font-size:20px;
        font-weight:bold;

    }
    
`
